import { render, staticRenderFns } from "./Sm600Black.vue?vue&type=template&id=a3174898&scoped=true&"
var script = {}
import style0 from "./Sm600Black.vue?vue&type=style&index=0&id=a3174898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3174898",
  null
  
)

export default component.exports